/** Registered overlay catalog keys (must match platform REGISTERED_OVERLAY_CATALOG_KEYS). */
export const REGISTERED_OVERLAY_CATALOG_KEYS = new Set(['developmentTip']);

export function isRegisteredOverlayCatalogKey(catalogKey) {
  return REGISTERED_OVERLAY_CATALOG_KEYS.has(catalogKey);
}

/**
 * Open a registered customer overlay by catalogKey.
 * @returns {boolean} true when handled
 */
export function openCustomerFeatureOverlay(store, catalogKey) {
  if (catalogKey === 'developmentTip') {
    store.commit('setShowDevTipps', true);
    return true;
  }
  return false;
}
